export default {
  name: "IconMixin",
  data() {
    return {};
  },
  props: {
    settings: {
      type: Object
    }
  },
  components: {},
  computed: {
    active() {
      if (this.settings.active) {
        return this.settings.active;
      } else {
        return false;
      }
    },
    strokeStyle() {
      const strokeWidth =
        this.settings && this.settings.strokeWidth
          ? this.settings.strokeWidth
          : 1.5;
      return { strokeWidth: strokeWidth };
    }
  },
  methods: {}
};
